import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ModalContainer from 'react-modal-promise';
import { toast } from 'react-toastify';

import Pagination from 'components/Pagination/Pagination';
import {
  updateOffloadAmount,
  getLeaseById,
  findPurchase,
  deleteLineItemsById,
  partialRefund,
  clearPartialRefundError,
  fetchPurchaseContractByUserId,
} from 'actions/purchases';
import {
  getIncludedInGroups,
  getPartialRefundErrorMessage,
  getPurchaseContractsByUserId,
} from 'reducers';
import PurchaseLineItemLeaseModal from './PurchaseLineItemLeaseModal';
import PurchaseLineItemDeleteModal from './PurchaseLineItemDeleteModal';
import PurchaseLineItemPartialRefundModal from './PurchaseLineItemPartialRefundModal';
import PurchaseItem from './PurchaseItem';
import FormError from '../FormError';
import { scrollToBlock } from 'helpers/scrolls';
import { getError } from 'helpers/errors';

class PurchaseItemList extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.updateRefundForLineItem = this.updateRefundForLineItem.bind(this);
    this.validateRefundValue = this.validateRefundValue.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.changeEditState = this.changeEditState.bind(this);
    this.changeRefundState = this.changeRefundState.bind(this);
    this.deleteLineItemModal = this.deleteLineItemModal.bind(this);
    this.refundLineItemModal = this.refundLineItemModal.bind(this);
    this.deleteLineItemsById = this.deleteLineItemsById.bind(this);
    this.partialRefund = this.partialRefund.bind(this);
    this.markLineToDelete = this.markLineToDelete.bind(this);

    this.state = {
      isModalOpen: false,
      isEditState: false,
      isRefundState: false,
      error: {
        message: '',
        lineitemId: null,
      },
      deleteError: null,
      refundError: null,
      linesItemsToDelete: [],
      chargeTypes: ['affirm', 'affirm2'],
      refund: {
        lineItemsToRefund: [],
        refundErrorList: [],
      },
    };
  }

  componentDidMount() {
    const { purchase, fetchPurchaseContractByUserId } = this.props;

    if (this.loadContracts) {
      fetchPurchaseContractByUserId(purchase.user_profile, purchase.id);
    }
  }

  componentWillUnmount() {
    this.checkAndClearPartialRefundError();
  }

  get isStatusPending() {
    const { purchase } = this.props;

    return purchase.status === 'pending';
  }

  get isStatusOffload() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return purchase.status === 'offload';
  }

  get isStatusOpen() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return purchase.status === 'open';
  }

  get showAddLineItemButton() {
    const { isViewPage } = this.props;

    return (
      (this.isStatusPending || this.isStatusOverdue || this.isStatusOpen) &&
      isViewPage
    );
  }

  get isStatusOverdue() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return purchase.status === 'overdue';
  }

  get isChargeTypePayTomorrow() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return purchase.charge_type === 'paytomorrow';
  }

  get canChangeOffloadAmount() {
    const { items } = this.props;
    const { isEditState } = this.state;

    return (
      this.isStatusOffload &&
      isEditState &&
      items.some((itemLine) => itemLine.item_type === 'lease_buyout')
    );
  }

  get lineItemsExist() {
    const {
      purchase: { line_items },
    } = this.props;

    return line_items && line_items.length ? true : false;
  }

  get showRefund() {
    const { isAdmin, purchase } = this.props;

    return (
      isAdmin &&
      purchase?.status === 'complete' &&
      purchase.purchase_type !== 'refund'
    );
  }

  get error() {
    const { partialRefundError } = this.props;
    const { error, refundError } = this.state;

    if (refundError) return refundError;
    if (partialRefundError) return partialRefundError;
    if (error.message) return error;
    return null;
  }

  get loadContracts() {
    const { purchase } = this.props;

    if (!purchase) return false;
    return this.isChargeTypePayTomorrow && this.isStatusOverdue;
  }

  checkAndClearPartialRefundError() {
    const {
      partialRefundError,
      clearPartialRefundError,
      purchase: { id },
    } = this.props;

    if (partialRefundError) clearPartialRefundError(id);
  }

  handleChange(itemLine, { type, value, checked }) {
    const { isRefundState } = this.state;

    if (isRefundState) {
      if (type === 'checkbox') {
        this.updateRefundForLineItem(itemLine, value, checked);
        return;
      }

      if (type === 'number') {
        this.updateRefundForLineItem(itemLine, value);
        return;
      }
    } else {
      if (type === 'checkbox') {
        this.markLineToDelete(itemLine, checked);
        return;
      }
    }
  }

  validateRefundValue(id, value, isFullRefund) {
    const { refund } = this.state;
    const { refundErrorList, lineItemsToRefund } = refund;
    const valueToNumber = Number(value);

    if (isFullRefund) {
      return true;
    }

    if (isNaN(valueToNumber) || value === '' || valueToNumber <= 0) {
      const mappedRefundErrorList = [...refundErrorList];
      mappedRefundErrorList.push({
        id,
        message: 'Value is not valid.',
        hasError: true,
      });
      this.setState({
        refund: {
          lineItemsToRefund,
          refundErrorList: [...mappedRefundErrorList],
        },
      });
      return false;
    }

    return true;
  }

  updateRefundForLineItem(line, value, isFullRefund) {
    const { items } = this.props;
    const { id, title, description } = line;

    const { refund } = this.state;
    const { lineItemsToRefund, refundErrorList } = refund;
    const item = items.find((i) => i.id === line.id);

    const lineItem = lineItemsToRefund.find((lineItem) => lineItem.id === id);
    const filteredRefundErrorList = refundErrorList.filter(
      (refundError) => refundError.id !== id,
    );
    const refundValue = isFullRefund
      ? item.price
      : (typeof value === 'undefined' || value === 'on') &&
          lineItem?.refund_amount
        ? lineItem?.refund_amount
        : value;

    const isValid = this.validateRefundValue(id, refundValue, isFullRefund);

    let updatedLinesItemsToRefund;
    if (lineItem) {
      updatedLinesItemsToRefund = lineItemsToRefund.filter(
        (lineItem) => lineItem.id !== id,
      );
      updatedLinesItemsToRefund.push({
        ...lineItem,
        refund_amount: refundValue,
        price: item.price,
        full_refund: isFullRefund,
      });
    } else {
      updatedLinesItemsToRefund = [...lineItemsToRefund];
      updatedLinesItemsToRefund.push({
        id,
        title,
        description,
        refund_amount: refundValue,
        price: item.price,
        full_refund: isFullRefund,
      });
    }

    this.setState((state) => ({
      refund: {
        refundErrorList: isValid
          ? [...filteredRefundErrorList]
          : state.refund.refundErrorList,
        lineItemsToRefund: [...updatedLinesItemsToRefund],
      },
    }));
  }

  markLineToDelete(line, checked) {
    const { linesItemsToDelete } = this.state;
    const { id, title, description, price } = line;

    if (checked) {
      this.setState({
        linesItemsToDelete: [
          ...new Set([
            ...linesItemsToDelete,
            { id, title, description, price },
          ]),
        ],
      });
    } else {
      this.setState({
        linesItemsToDelete: [
          ...linesItemsToDelete.filter((item) => id !== item.id),
        ],
      });
    }
  }

  changeEditState() {
    const { isEditState } = this.state;

    this.setState({ isEditState: !isEditState, isRefundState: false });
  }

  changeRefundState() {
    const { isRefundState } = this.state;

    const newRefundState = !isRefundState;

    if (newRefundState) {
      this.tableHeight = document.getElementById(
        'purchase-lineitem-table',
      ).offsetHeight;
      scrollToBlock('#purchase-lineitem-title');
    } else {
      const currentTableHeight = document.getElementById(
        'purchase-lineitem-table',
      ).offsetHeight;
      const scrollCorrection = currentTableHeight - this.tableHeight;
      window.scrollTo({
        top: document.querySelector('html').scrollTop - scrollCorrection,
        behavior: 'smooth',
      });
    }

    this.setState({
      isRefundState: newRefundState,
      isEditState: false,
      refund: {
        lineItemsToRefund: [],
        refundErrorList: [],
      },
      refundError: null,
    });
  }

  async deleteLineItemModal() {
    this.checkAndClearPartialRefundError();
    const { linesItemsToDelete } = this.state;

    if (!linesItemsToDelete.length) return;

    this.setState({ isModalOpen: true });
    const confirmResult = await PurchaseLineItemDeleteModal({
      open: this.state.isModalOpen,
      linesItemsToDelete,
    });

    if (confirmResult) {
      await this.deleteLineItemsById(linesItemsToDelete);
      this.setState({ isEditState: false });
    }

    this.setState({ isModalOpen: false });
  }

  async refundLineItemModal() {
    this.checkAndClearPartialRefundError();
    const {
      refund: { lineItemsToRefund, refundErrorList },
    } = this.state;
    const invalidItems = refundErrorList.map((item) => item.id);
    const validLineItemsToRefund = lineItemsToRefund.filter(
      (item) => !invalidItems.includes(item.id),
    );
    if (!validLineItemsToRefund.length) return;

    this.setState({ isModalOpen: true });
    const confirmResult = await PurchaseLineItemPartialRefundModal({
      open: this.state.isModalOpen,
      lineItemsToRefund: validLineItemsToRefund,
    });

    if (confirmResult) {
      await this.partialRefund(validLineItemsToRefund);
    }

    this.setState({ isModalOpen: false });
  }

  async handleOpenModal(leaseId, lineId) {
    if (!leaseId) return;
    const { getLeaseById, purchase, findPurchase } = this.props;

    try {
      const lease = await getLeaseById(leaseId);
      this.setState({ isModalOpen: true });
      const confirmResult = await PurchaseLineItemLeaseModal({
        open: this.state.isModalOpen,
        lease,
      });

      if (confirmResult) {
        const data = {
          cancelOffload: {},
          purchaseRemoveItem: {
            lineitem: lineId,
            no_auto_close: true,
          },
          purchaseAddItem: {
            item_type: 'lease_buyout',
            item_id: leaseId,
            subscription: lease.subscription,
            att_subscription: lease.att_subscription,
          },
          lease: {
            ...lease,
            total: Number(confirmResult).toFixed(2),
          },
          purchaseId: purchase.id,
          leaseId,
        };

        await this.updateOffloadAmount(data);
        this.setState({ isEditState: false });
      }
    } catch (error) {
      this.setState({ isModalOpen: false, error: { message: error.message } });
    }

    await findPurchase(purchase.id);
  }

  async deleteLineItemsById(linesItemsToDelete) {
    const { purchase, deleteLineItemsById } = this.props;

    try {
      await deleteLineItemsById(purchase.id, linesItemsToDelete);
    } catch (err) {
      this.setState({ deleteError: err?.errors || getError(err) });
    }

    this.setState({ linesItemsToDelete: [] });
  }

  async partialRefund(lineItemsToRefund) {
    const {
      purchase: { id },
      partialRefund,
      findPurchase,
    } = this.props;
    let dataItems = [...lineItemsToRefund];
    dataItems = dataItems.map((item) => {
      if (item.full_refund) {
        return {
          id: item.id,
          full_refund: item.full_refund,
        };
      } else {
        return {
          id: item.id,
          refund_amount: item.refund_amount,
        };
      }
    });
    const requestData = { line_items: dataItems };
    this.setState({ refundError: null });
    const response = await partialRefund(id, requestData);

    if (response?.data?.errors) {
      this.setState({
        refundError: response?.data?.errors?.length
          ? response?.data?.errors[0]
          : response?.data?.errors,
      });
      return;
    }
    if (response && response.status === 200) {
      await findPurchase(id);
      toast.success('Partial refund request completed');
    }

    this.changeRefundState();
  }

  async updateOffloadAmount(data) {
    const { updateOffloadAmount } = this.props;

    await updateOffloadAmount(data);
  }

  getNextPage = (pageNum) => {
    const {
      qsSearch,
      pageBaseUrl = `/purchases/${this.props.purchase.id}/view`,
    } = this.props;
    const newQuery = qsSearch || {};
    newQuery['lineItemsPage'] = pageNum;
    const searchParams = new URLSearchParams(newQuery);
    return `${pageBaseUrl}?${searchParams.toString()}`;
  };

  render() {
    const {
      items,
      purchase,
      findPurchase,
      actionComponent,
      contracts,
      title = 'Purchased Items',
      isAdmin = false,
      isManager = false,
      isBillingAgent = false,
      isAgent = false,
      lineItemsPage = 1,
      lineItemsCount,
      isViewPage,
    } = this.props;
    const {
      isEditState,
      isRefundState,
      refund: { refundErrorList, lineItemsToRefund },
    } = this.state;

    const lineItemsPerPage = purchase?.line_items.length || 50;
    const lineItemsAmount =
      typeof lineItemsCount !== 'undefined'
        ? lineItemsCount
        : purchase && purchase.line_items_count;
    const lineItemsPageCount = lineItemsAmount
      ? Math.ceil(lineItemsAmount / lineItemsPerPage)
      : 1;

    if ((!items || items.length === 0) && !this.showAddLineItemButton) {
      return null;
    }

    return (
      <React.Fragment>
        <h4 id="purchase-lineitem-title">{title}</h4>
        <table id="purchase-lineitem-table" className="table table-striped">
          <thead>
            <tr>
              {isEditState && <th>Select to remove</th>}
              {isRefundState && <th>Refund</th>}
              <th>ID</th>
              <th>Title</th>
              <th>Description</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Sub ID</th>
              <th>ICC ID</th>
              <th>Identifier</th>
              <th>Price</th>
              <th></th>
              {this.canChangeOffloadAmount && <th>Open modal</th>}
              {actionComponent && <th></th>}
            </tr>
          </thead>
          <tbody>
            {items.map((itemLine) => (
              <PurchaseItem
                key={itemLine.id}
                itemLine={itemLine}
                lineItemsToRefund={lineItemsToRefund}
                refundError={refundErrorList.find(
                  (refundError) => refundError.id === itemLine.id,
                )}
                handleOpenModal={this.handleOpenModal}
                handleChange={this.handleChange}
                isStatusOffload={this.isStatusOffload}
                canChangeOffloadAmount={this.canChangeOffloadAmount}
                isEditState={isEditState}
                isRefundState={isRefundState}
                actionComponent={actionComponent}
                purchase={purchase}
                findPurchase={findPurchase}
                isViewPage={isViewPage}
              />
            ))}
          </tbody>
        </table>
        <Pagination
          count={lineItemsPageCount}
          current={lineItemsPage}
          url={this.getNextPage}
        />
        {(isAdmin ||
          isBillingAgent ||
          isManager ||
          isAgent ||
          this.showAddLineItemButton ||
          this.showRefund) && (
          <div className="purchase-items-btn-wrapper">
            {(isAdmin || isBillingAgent || isManager || isAgent) &&
              (isEditState ? (
                <React.Fragment>
                  <button
                    className="btn btn-default"
                    onClick={this.changeEditState}
                  >
                    Stop editing
                  </button>
                  <button
                    className="btn btn-danger ml-10 mr-10"
                    onClick={this.deleteLineItemModal}
                  >
                    Remove line items
                  </button>
                </React.Fragment>
              ) : (
                this.lineItemsExist && (
                  <button
                    className="btn btn-default mr-10"
                    onClick={this.changeEditState}
                  >
                    Edit line items
                  </button>
                )
              ))}
            {this.showRefund && (
              <React.Fragment>
                {isAdmin &&
                  (isRefundState ? (
                    <React.Fragment>
                      <button
                        className="btn btn-default"
                        onClick={this.changeRefundState}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-danger ml-10 mr-10"
                        onClick={this.refundLineItemModal}
                      >
                        Refund
                      </button>
                    </React.Fragment>
                  ) : (
                    <button
                      className="btn btn-default mr-10"
                      onClick={this.changeRefundState}
                    >
                      Partial refund
                    </button>
                  ))}
              </React.Fragment>
            )}
            {this.showAddLineItemButton && (
              <Link to={`/purchases/${purchase.id}/add-items`}>
                <button className="btn btn-default">Add line items</button>
              </Link>
            )}
          </div>
        )}
        <ModalContainer />
        {this.error && <FormError error={this.error} />}
        {this.state.deleteError && <FormError error={this.state.deleteError} />}
        <br />
        {this.loadContracts &&
          contracts.length &&
          contracts.map((contract) => (
            <p key={contract.id}>
              <Link to={`/device/contracts/${contract.id}/view`}>
                Go to contract ID {contract.id}
              </Link>
            </p>
          ))}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, { purchase: { id } }) => ({
  partialRefundError: getPartialRefundErrorMessage(state),
  contracts: getPurchaseContractsByUserId(state.purchases, id),
  isAgent: getIncludedInGroups(state, ['AGENT']),
});

const mapDispatchToProps = {
  updateOffloadAmount,
  deleteLineItemsById,
  getLeaseById,
  findPurchase,
  partialRefund,
  clearPartialRefundError,
  fetchPurchaseContractByUserId,
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseItemList);
